import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router';
import { GlobalNavigation, MENU_ITEMS } from '@/components/organisms';
import * as Styled from './MainLayout.style';
export const MainLayout = () => {
    const location = useLocation();
    useEffect(() => {
        const currentItem = MENU_ITEMS.find(item => item.path === location.pathname);
        if (currentItem) {
            document.title = currentItem.name;
        }
        else {
            document.title = 'LMS Sebrae';
        }
    }, [location]);
    return (_jsxs(Styled.Container, { children: [_jsx(GlobalNavigation, {}), _jsx(Styled.MainContent, { children: _jsx(Outlet, {}) })] }));
};
//# sourceMappingURL=MainLayout.js.map